import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountingReportsService {
  private apiUrl = `${environment.apiUrl}/accounting-reports`;

  constructor(private http: HttpClient) {}

  getProfitLoss(startDate?: string, endDate?: string): Observable<any> {
    let params = {};
    if (startDate && endDate) params = { startDate, endDate };
    return this.http.get(`${this.apiUrl}/profit-loss`, { params });
  }

  getBalanceSheet(asOfDate?: string): Observable<any> {
    let params = {};
    if (asOfDate) params = { asOfDate };
    return this.http.get(`${this.apiUrl}/balance-sheet`, { params });
  }

  getSalesTaxLiability(startDate?: string, endDate?: string): Observable<any> {
    let params = {};
    if (startDate && endDate) params = { startDate, endDate };
    return this.http.get(`${this.apiUrl}/sales-tax`, { params });
  }

  getCogs(startDate?: string, endDate?: string): Observable<any> {
    let params = {};
    if (startDate && endDate) params = { startDate, endDate };
    return this.http.get(`${this.apiUrl}/cogs`, { params });
  }

  getCashFlow(startDate?: string, endDate?: string): Observable<any> {
    let params = {};
    if (startDate && endDate) params = { startDate, endDate };
    return this.http.get(`${this.apiUrl}/cash-flow`, { params });
  }
}
